import {
  Trait,
  TraitIntStruct,
  TraitLongStruct,
  TraitDoubleStruct,
  TraitStringStruct,
  TraitBooleanStruct,
  TraitDatetimeStruct,
} from '@playq/services-common-traits';
import { TraitDataType } from '@playq/octopus2-analytics';

import { EntriesTrait } from '../types';

export function traitToType(entry: Trait) {
  switch (entry.getFullClassName()) {
    case TraitIntStruct.FullClassName:
      return TraitDataType.Int;
    case TraitLongStruct.FullClassName:
      return TraitDataType.Long;
    case TraitDoubleStruct.FullClassName:
      return TraitDataType.Double;
    case TraitStringStruct.FullClassName:
      return TraitDataType.String;
    case TraitBooleanStruct.FullClassName:
      return TraitDataType.Boolean;
    case TraitDatetimeStruct.FullClassName:
      return TraitDataType.DateTime;
    default:
      throw new Error(`Unexpected trait entry class: ${entry.getClassName()}`);
  }
}

export const toFormatTraits = (trait: Trait): EntriesTrait => {
  const { value, name } = trait.serialize();

  return { name, type: traitToType(trait), value };
};
